import { createClassed } from "@tw-classed/react";
import { twMerge } from "tailwind-merge";

export const { classed } = createClassed({ merger: twMerge });
export { twMerge };
